<div toolbar>
  @switch (ts.boardMode()) {
    @case (BoardMode.Prepare) {
      <div>
        <button (click)="clickPlay($event)" mat-icon-button>
          <mat-icon>sports_esports</mat-icon>
        </button>
      </div>
      <div controls>
        <div title>Spielmodus</div>
        <mat-button-toggle-group [(ngModel)]="ts.gameMode">
          <mat-button-toggle [value]="GameMode.Normal" i18n>Normal</mat-button-toggle>
          <mat-button-toggle [value]="GameMode.Quick" i18n>Schnelles Spiel</mat-button-toggle>
          <mat-button-toggle [value]="GameMode.Sabotage" i18n>Sabotage</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    }
    @case (BoardMode.Play) {
      <div controls>
        <button (click)="clickPrepare($event)" mat-icon-button>
          <mat-icon>chevron_left</mat-icon>
        </button>
      </div>
    }
  }
  <div>
    @if (!Utils.isEmpty(bs.token)) {
      <app-close-button [data]="closeData"></app-close-button>
      <button [matMenuTriggerFor]="userMenu" mat-icon-button>
        <mat-icon>person</mat-icon>
      </button>
      <mat-menu #userMenu="matMenu">
        <button (click)="onClick('settings')" mat-menu-item>
          <mat-icon>person</mat-icon>
          <span>{{ globals.appData?.person?.firstname }}</span>
        </button>
        <button (click)="onClick('password')" mat-menu-item>
          <mat-icon>key</mat-icon>
          <span i18n>Password</span>
        </button>
        <button (click)="onClick('whatsnew')" mat-menu-item>
          <mat-icon>info_outline</mat-icon>
          <span i18n>Once upon a time...</span>
        </button>
        <button (click)="onClick('impressum')" mat-menu-item>
          <mat-icon>account_balance</mat-icon>
          <span i18n>Impressum</span>
        </button>
        <button (click)="onClick('dsgvo')" mat-menu-item>
          <mat-icon>policy</mat-icon>
          <span i18n>DSGVO</span>
        </button>
        <mat-divider></mat-divider>
        <button (click)="onClick('logout')" mat-menu-item>
          <mat-icon>logout</mat-icon>
          <span i18n>Logout</span>
        </button>
      </mat-menu>
    }
  </div>
</div>
@if (bs.token != null) {
  <app-site-tacta></app-site-tacta>
} @else {
  <div [style]="styleForMain" mainpanel>
  </div>
}
<app-progress></app-progress>
